

export default {
  enums: [
    { id: 'NO_TREE', },
    { id: 'ONE_LEVEL', },
    { id: 'ALL_TREE', },
  ]
};
